import { Component, ElementRef, Inject, OnInit, Output, ViewChild } from '@angular/core';

import { HttpService } from '../../../core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';


@Component({
    selector: 'add-project-dialog',
    templateUrl: './add-project-dialog.component.html',
    styleUrls: ['./add-project-dialog.component.scss'],
})

export class AddProjectDialogComponent implements OnInit {


    constructor(
        private httpService: HttpService,
        private dialogRef: MatDialogRef<any>,
        private fb: FormBuilder, private toastrService: ToastrService, private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {

    }

    ngOnInit(): void {

    }

    cancel() {
        this.dialogRef.close();
    }


}
